import React from 'react';
import { Card, CardBody, UncontrolledTooltip } from 'reactstrap';
import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import DeltaIndicator from './DeltaIndicator';
import { humanizeDuration } from './helpers';

// Combined MTBF + MTTR card. Two stacked metrics, each with delta.
// MTBF: higher is better (longer uptime). MTTR: lower is better (faster repair).

const Metric = ({ label, hours, delta, betterIsUp, t }) => (
  <div>
    <div className="d-flex align-items-center gap-2">
      <div className="font-size-24 fw-bold">{humanizeDuration(hours, t)}</div>
      <DeltaIndicator delta={delta} betterIsUp={betterIsUp} />
    </div>
    <div className="text-muted font-size-12 mt-1">{label}</div>
  </div>
);

export default function MtbfMttrCard({ mtbfHours, mttrHours, mtbfDelta, mttrDelta }) {
  const { t } = useTranslation();
  const tooltipId = 'mtbf-mttr-info';

  return (
    <Card className="h-100">
      <CardBody>
        <div className="d-flex align-items-center gap-2 fw-semibold mb-3">
          {t('shared.global_org.overview.mtbf_mttr_title', 'MTBF, MTTR')}
          <Info size={14} id={tooltipId} className="text-muted" style={{ cursor: 'help' }} />
          <UncontrolledTooltip target={tooltipId} placement="top">
            {t('shared.global_org.overview.mtbf_mttr_tooltip',
              'Mean Time Between Failures measures asset uptime. Mean Time To Repair measures asset downtime.')}
          </UncontrolledTooltip>
        </div>
        <div className="d-flex gap-4">
          <Metric
            label={t('shared.global_org.mtbf', 'MTBF')}
            hours={mtbfHours}
            delta={mtbfDelta}
            betterIsUp
            t={t}
          />
          <Metric
            label={t('shared.global_org.mttr', 'MTTR')}
            hours={mttrHours}
            delta={mttrDelta}
            betterIsUp={false}
            t={t}
          />
        </div>
      </CardBody>
    </Card>
  );
}
